'use client';

import { SearchParams } from '@api/models';
import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { useLocale } from 'next-intl';

import { type SearchResult, search } from '../services/search.service';

/** The search page's results (activities, Hubs) for its filters. */
export function useSearch(
  params: SearchParams = {},
  options?: Omit<UseQueryOptions<SearchResult, Error>, 'queryKey' | 'queryFn'>
) {
  const locale = useLocale();
  const stableKey = JSON.stringify(params);

  return useQuery<SearchResult, Error>({
    queryKey: ['search', locale, stableKey],
    queryFn: () => search(params, locale),
    staleTime: 5 * 60 * 1000,
    placeholderData: (previousData) => previousData,
    ...options
  });
}
